export class AuditLog {
    constructor(public tenantId: number, public userId: string, public additionalInfo: string){
        this.tenantId = tenantId;
        this.userId = userId;
        this.additionalInfo = additionalInfo;
    }
}
  